import { type FC } from "react";

import { formatDateTimeFromISO } from "widgets";

import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import ListCellContent, { type ListCellItem } from "./ListCellContent.js";
import { TableCell } from "./TableCell.js";
import { CELL_TYPE, nonBreakingSpace } from "@/settings/settings.js";

export function getDateTimeItems(value, colDef): ListCellItem[] {
  const multiValues = Array.isArray(value) ? value : [value];

  // in theory the "dateAsString" is already ISO format (OR unparseable string after editing !)
  return multiValues.map((dateISOFormatted: string) => {
    return {
      value:
        (dateISOFormatted && formatDateTimeFromISO(dateISOFormatted, { hideTime: colDef.type === CELL_TYPE.DATE })) ||
        nonBreakingSpace,
      tooltip:
        colDef.type === CELL_TYPE.DATE_TIME ? formatDateTimeFromISO(dateISOFormatted, { full: true }) : undefined,
    };
  });
}

const DateCell: FC<IAgGridCellProps> = (props) => {
  if (props.data == null) {
    return null;
  }

  return (
    <TableCell style={{ textAlign: "right" }}>
      <ListCellContent
        items={getDateTimeItems(props.value, props.colDef)}
        colDef={props.colDef}
        context={props.context}
      />
    </TableCell>
  );
};

export default DateCell;
